{
  "w": 8,
  "h": 5,
  "rows": [
    "...ww...",
    ".wwWWW..",
    "wWwwwWWW",
    "wwwwwwww",
    ".wwwwww."
  ],
  "legend": {
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
